"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModelBuilder = exports.useModelField = exports.useModel = void 0;
const react_1 = require("react");
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const LoadableModel_1 = require("./LoadableModel");
const Model_1 = require("./Model");
const isLoadableModel = (model) => {
    return (typeof model.getMetaAsObservable === 'function' &&
        typeof model.getMeta === 'function');
};
function useModel(model) {
    const unmountRef = (0, react_1.useRef)(false);
    const [value, setValue] = (0, react_1.useState)(model.getValue());
    const [meta, setMeta] = (0, react_1.useState)(isLoadableModel(model) ? model.getMeta() : LoadableModel_1.INITIAL_LOADABLE_MODEL_META_DATA);
    const [sub] = (0, react_1.useState)({ current: null });
    if (!sub.current) {
        sub.current = model.asObservable().subscribe((value) => {
            if (!unmountRef.current) {
                setValue(value);
            }
        });
        if (isLoadableModel(model)) {
            sub.current.add(model.getMetaAsObservable().subscribe((meta) => {
                if (!unmountRef.current) {
                    setMeta(Object.assign({}, meta));
                }
            }));
        }
    }
    (0, react_1.useEffect)(() => {
        return () => {
            var _a;
            unmountRef.current = true;
            (_a = sub.current) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            sub.current = null;
        };
    }, []);
    return { value, meta };
}
exports.useModel = useModel;
function useModelField(model, fieldKey) {
    const [value, setValue] = (0, react_1.useState)(model.getValue()[fieldKey]);
    const [meta, setMeta] = (0, react_1.useState)(isLoadableModel(model) ? model.getMeta() : LoadableModel_1.INITIAL_LOADABLE_MODEL_META_DATA);
    const [sub] = (0, react_1.useState)({ current: null });
    if (!sub.current) {
        sub.current = model.fieldChanges(fieldKey).subscribe((value) => {
            setValue(value.value);
        });
        if (isLoadableModel(model)) {
            sub.current.add(model.getMetaAsObservable().subscribe((meta) => {
                setMeta(Object.assign({}, meta));
            }));
        }
    }
    (0, react_1.useEffect)(() => {
        return () => {
            var _a;
            (_a = sub.current) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            sub.current = null;
        };
    }, []);
    return {
        value,
        meta
    };
}
exports.useModelField = useModelField;
function useModelBuilder(initialValue, deps = [], options = {}) {
    const depsRef = (0, react_1.useRef)(deps);
    const modelRef = (0, react_1.useRef)(null);
    if (!modelRef.current) {
        modelRef.current = new Model_1.Model(initialValue);
    }
    (0, react_1.useEffect)(() => {
        var _a;
        if (!((options === null || options === void 0 ? void 0 : options.comparator) || fast_deep_equal_1.default)(depsRef.current, deps)) {
            depsRef.current = deps;
            (_a = modelRef.current) === null || _a === void 0 ? void 0 : _a.setValue(initialValue);
            return;
        }
    });
    (0, react_1.useEffect)(() => {
        return () => {
            var _a;
            (_a = modelRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        };
    }, []);
    return modelRef.current;
}
exports.useModelBuilder = useModelBuilder;
//# sourceMappingURL=hooks.js.map